export { HeroIcon, type HeroIconProps } from './HeroIcon';
